import { render, staticRenderFns } from "./AdminProjectCode.vue?vue&type=template&id=80153300&"
import script from "./AdminProjectCode.vue?vue&type=script&lang=js&"
export * from "./AdminProjectCode.vue?vue&type=script&lang=js&"
import style0 from "./AdminProjectCode.vue?vue&type=style&index=0&id=80153300&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports